import {
  deleteApiAdminsId,
  getApiAdminsId,
  postApiAdmins,
  putApiAdminsId,
} from '@/shared/api'
import { createMutation, createQuery } from '@farfetched/core'

export const adminByIdQuery = createQuery({
  handler: getApiAdminsId,
})

export const adminCreate = createMutation({
  handler: postApiAdmins,
})

export const adminUpdate = createMutation({
  handler: putApiAdminsId,
})

export const adminDelete = createMutation({
  handler: deleteApiAdminsId,
})
